import { TABLA_DETALLE_POR_CONDICION_LINEA_3 } from '../../../../../config/tables'
import { TablaDetallePorCondicionLinea3Service } from '../../../../../models/movimiento/distribucionDetallePorCondicion/Tabla_detalle_por_condicion_linea_3'
import { COLUMNS_DETALLE_POR_CONDICION_LINEA_3, COLUMNS_DETALLE_POR_CONDICION_LINEA_3_TO_PRINT } from './constantesDetallePorCondicionLinea3'
import { pdfCustomToolbarGenerator } from '../../../../../models/tools/generarPdf'

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_DETALLE_POR_CONDICION_LINEA_3
    })
    const promiseTablaDetallePorCondicionLinea3 = TablaDetallePorCondicionLinea3Service.getDataTablaDetallePorCondicionLinea3()
    const promiseTablaDetallePorCondicionLinea3Total = TablaDetallePorCondicionLinea3Service.getDataTablaDetallePorCondicionLinea3Total()
    Promise.all([promiseTablaDetallePorCondicionLinea3, promiseTablaDetallePorCondicionLinea3Total]).then(callback)
    function callback (dataArray) {
      const dataCombinada = dataArray[0].filas || []
      const filaTotalArreglada = dataArray[1].filas[0]
      filaTotalArreglada['cereal'] = 'Total'
      dataCombinada.push(filaTotalArreglada)
      const customToolbar = pdfCustomToolbarGenerator(
        'Distribución Por Condición Sector 3',
        dataCombinada,
        COLUMNS_DETALLE_POR_CONDICION_LINEA_3_TO_PRINT,
        'portrait')
      dispatch({
        type: 'UPDATE_MUITABLE',
        newState: {
          columns: COLUMNS_DETALLE_POR_CONDICION_LINEA_3,
          data: dataCombinada,
          title: `Distribución Por Condición Sector 3`,
          isLoading: false,
          fixed2Decimales: true,
          extraOptions: { customToolbar, print: false, pagination: false }
        },
        id: TABLA_DETALLE_POR_CONDICION_LINEA_3
      })
    }
  }
}
